import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty-showcase-twodimension',
  templateUrl: './empty-showcase-twodimension.component.html',
  styleUrls: ['./empty-showcase-twodimension.component.scss']
})
export class EmptyShowcaseTwodimensionComponent implements OnInit {
  @Input() spaceData;
  constructor() { }

  ngOnInit() {
  }

}
